/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { capitalize } from 'lodash'

import { EuiFlexGroup, EuiIcon, EuiTitle } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import type { DefaultSolutionView } from '@modules/deployment-creation-wizard/types'

import { getPrettySolutionType, toSolutionType } from './lib'

import type { FC } from 'react'

const SolutionViewHeader: FC<{ solutionView: DefaultSolutionView }> = ({ solutionView }) => (
  <EuiFlexGroup alignItems='center'>
    <EuiIcon type={`logo${capitalize(toSolutionType(solutionView))}`} size='xl' />
    <EuiTitle>
      <h2>
        <FormattedMessage {...getPrettySolutionType(solutionView)} />
      </h2>
    </EuiTitle>
  </EuiFlexGroup>
)

export default SolutionViewHeader
